"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "initTheme", {
  enumerable: true,
  get: function get() {
    return _ThemeBuilder.initTheme;
  }
});

var _ThemeBuilder = require("./ThemeBuilder");